import Backdrop from "@mui/material/Backdrop";
// import Loader from "assets/images/Loader.gif";
import { Box, CircularProgress } from "@mui/material";

interface CustomLoaderProps {
  isLoading?: boolean;
}

const CustomLoader = (props: CustomLoaderProps) => {
  return (
    <>
      {props.isLoading && (
        <Box
          role="status"
          aria-live="polite"
          sx={{
            position: "fixed",
            inset: 0,
            bgcolor: "rgba(255,255,255,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
          }}
        >
          <CircularProgress aria-label="Loading" />
          <Box
            component="span"
            sx={{
              position: "absolute",
              width: "1px",
              height: "1px",
              overflow: "hidden",
              clip: "rect(0 0 0 0)",
            }}
          >
            Loading
          </Box>
        </Box>
      )}
    </>
  );
};

export default CustomLoader;
